import { EsignRequestRedirect } from "@/pages/esign/EsignRequestRedirect.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";

export const esignRoutes: RouteConfig[] = [
  {
    path: "/esign/requests/:requestId",
    element: <EsignRequestRedirect />,
  },
];
